import { CognitoUserPool, ICognitoUserPoolData } from 'amazon-cognito-identity-js';
const poolData: ICognitoUserPoolData = {
    UserPoolId: "us-east-1_Es6mGuPJn",
    ClientId: "1cknd5biikfv27hghs78struco",
};
const userPool = new CognitoUserPool(poolData);
export default userPool;